import { architectureService } from '../../lib/services'
import { linksTypes } from '../types'

const get = appName => async dispatch => {
    try {
        dispatch({ type: linksTypes.LINKS_REQUEST })
        const data = await architectureService.getLinks(appName)
        const links =
        data?.map(l => ({
            id: l.ResourceId,
            name: l.ResourceName,
            nodes: l.ChildServices?.map(n => ({ id: n.ResourceId, name: n.ResourceName })) ?? [],
        })) ?? []
        dispatch({ type: linksTypes.LINKS_SUCCESS, payload: { appName, links } })
    } catch (err) {
        console.error(err)
        dispatch({ type: linksTypes.LINKS_FAILURE })
    }
}

export const linksCreators = {
    get,
}
